import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-planificaciones',
  templateUrl: './planificaciones.component.html',
  styleUrls: ['./planificaciones.component.scss']
})
export class PlanificacionesComponent implements OnInit {
  /**
   * Variable que indica la pagina en la que te encuentras
   */
  p = 1;
  public planificaciones = [];
  public tipoUsuario = true;
  public documentId = null;
  public currentStatus = 1;
  public newPlanificForm = new FormGroup({
    ambito: new FormControl('', Validators.required),
    nucleo: new FormControl('', Validators.required),
    objetivo: new FormControl('', Validators.required),
    observaciones: new FormControl('', Validators.required),
    id: new FormControl('')
  });

  constructor(private firestoreService: FirestoreService) {
    this.newPlanificForm.setValue({
      id: '',
      ambito: '',
      nucleo: '',
      objetivo: '',
      observaciones: '',
    });
  }

  ngOnInit() {
    this.firestoreService.getPlanifics().subscribe(planificacionesSnapshot => {
      this.planificaciones = [];
      planificacionesSnapshot.forEach((planificacionesData: any) => {
        this.planificaciones.push({
          id: planificacionesData.payload.doc.id,
          data: planificacionesData.payload.doc.data()
        });
      });
      this.planificaciones.sort((a, b) => {
        return a.data.ambito.localeCompare(b.data.ambito);
      });
      this.planificaciones.sort((a, b) => {
        if ( a.data.ambito ===  b.data.ambito) {
          return a.data.nucleo.localeCompare(b.data.nucleo);
        }
        return;
      });
      this.planificaciones.sort((a, b) => {
        if ( a.data.ambito ===  b.data.ambito && a.data.nucleo ===  b.data.nucleo ) {
          return a.data.objetivo.localeCompare(b.data.objetivo);
        }
        return;
      });
    });
    this.validarAcciones();
  }

  limpiar() {
    this.newPlanificForm.reset();
  }

  validarAcciones() {
    if (sessionStorage.getItem('usuario')) {
      const user: any = JSON.parse(sessionStorage.getItem('usuario'));
      this.firestoreService.getUsuari(user.i.user.uid).subscribe(data => {
        const usuario: any = data.payload.data();
        if (usuario.perfil_usuar !== 'Administrador') {
          this.tipoUsuario = true;
          Swal.fire(
            'Aviso!',
            'Usuario Estándar, sin privilegios para realizar cambios, favor comuníquese con el administrador.',
            'warning'
          );
        } else {
          this.tipoUsuario = false;
        }
      });
    } else {
      this.tipoUsuario = false;
    }
  }

  public newplanificaciones(form, documentId = this.documentId) {
    if (this.currentStatus === 1) {
      const data = {
        ambito: form.ambito,
        nucleo: form.nucleo,
        objetivo: form.objetivo,
        observaciones: form.observaciones,
      };
      this.firestoreService.createPlanific(data).then(
        () => {
          this.newPlanificForm.reset();
          Swal.fire(
            'Creado!',
            'El registro se creo correctamente.',
            'success'
          );
        },
        error => {
          console.error(error);
        }
      );
    } else {
      const data = {
        ambito: form.ambito,
        nucleo: form.nucleo,
        objetivo: form.objetivo,
        observaciones: form.observaciones,
      };
      console.log('Documento editado exitósamente');
      this.firestoreService.updatePlanific(documentId, data).then(
        () => {
          this.currentStatus = 1;
          this.newPlanificForm.reset();
          Swal.fire(
            'Editado!',
            'El registro se edito correctamente.',
            'success'
          );
          console.log('Documento editado exitósamente');
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  public editPlanificaciones(documentId) {
    console.log(documentId);
    const editSubscribe = this.firestoreService.getPlanific(documentId).subscribe((planificaciones) => {
      this.currentStatus = 2;
      this.documentId = documentId;
      this.newPlanificForm.setValue({
        id: documentId,
        ambito: planificaciones.payload.data()['ambito'],
        nucleo: planificaciones.payload.data()['nucleo'],
        objetivo: planificaciones.payload.data()['objetivo'],
        observaciones: planificaciones.payload.data()['observaciones'],
      });
      editSubscribe.unsubscribe();
    });
  }

  public delPlanific(documentId) {
    Swal.fire({
      title: 'Estas seguro?',
      text: 'No podrás revertir esta accion!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrar!'
    }).then((result) => {
      if (result.value) {
        this.firestoreService.deletePlanific(documentId).then(() => {
          Swal.fire(
            'Borrado!',
            'El registro fue eliminado.',
            'success'
          );
        }, (error) => {
          console.error(error);
        });
      }
    });

  }
}
